import ChannelListContext from '@shared/components/utils/context/channelListContext';
import Container from '../../atoms/container/channelListCrewTextContainer';
import CrewTitle from '../../atoms/text/channelListCrewTitle';
import CrewMembers from '../../atoms/text/channelListCrewMembers';
import EventUtils from '../../../../shared/utils/events';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { useContext } from 'react';

interface Props {
  title: string;
  type: string;
}

export default function ChannelListCrewItem({ title, type }: Props) {
  const { event } = useContext(ChannelListContext);
  const data = EventUtils.getCrew(type, event);

  return (
    <>
      {data ? (
        <Container id={'channelListCrewItemContainer'}>
          <CrewTitle id={'crewTitle'}>{`${TranslationManager.get(
            title + (data.split(',').length > 1 ? '.PLURAL' : '.SINGULAR')
          )} `}</CrewTitle>
          <CrewMembers>{data}</CrewMembers>
        </Container>
      ) : (
        ''
      )}
    </>
  );
}
